<template>
  <div class="chart-container">
    <Doughnut :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  name: 'DonutChartWebsites',
  components: { Doughnut },
  props: {
    platformSales: {
      type: Object,
      required: true
    },
    height: {
      type: [Number, String],
      default: 150 // Default height for compact layout
    }
  },
  computed: {
    chartData() {
      const platforms = ['Flirt4Free', 'Streamate', 'LiveJasmin', 'Chaturbate', 'Stripchat', 'XLoveCam'];
      const data = [
        this.platformSales.flirt4free || 0,
        this.platformSales.streamate || 0,
        this.platformSales.livejasmin || 0,
        this.platformSales.chaturbate || 0,
        this.platformSales.stripchat || 0,
        this.platformSales.xlove || 0
      ];
      return {
        labels: platforms,
        datasets: [
          {
            data: data,
            backgroundColor: [
              'rgba(2, 168, 224, 0.5)',
              'rgba(35, 101, 159, 0.5)',
              'rgba(188, 0, 2, 0.5)',
              'rgba(255, 203, 74, 0.5)',
              'rgba(119, 2, 2, 0.5)',
              'rgba(0, 128, 0, 0.5)'
            ],
            borderColor: [
              'rgb(2, 168, 224)',
              'rgb(35, 101, 159)',
              'rgb(188, 0, 2)',
              'rgb(255, 203, 74)',
              'rgb(119, 2, 2)',
              'rgb(0, 128, 0)'
            ],
            borderWidth: 1
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false // Remove the legend (platform labels)
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const label = context.label || '';
                const value = context.raw || 0;
                return `${label}: $${value.toFixed(2)}`;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: v-bind(height + 'px'); /* Use the height prop dynamically */
  width: 100%;
}
</style>